import { cn } from "@/ds/utils";
import type { DataViewItemBaseProps } from "@/features/common/components/dataview/DataViewItemBaseProps";
import { TableCell, TableRow } from "@/ds/shadcn/components/ui/table";
import { AlertCircleIcon, EllipsisVerticalIcon } from "lucide-react";
import type { FC, PropsWithChildren } from "react";
import { DropdownMenu, DropdownMenuContent, DropdownMenuTrigger } from "@/ds/shadcn/components/ui/dropdown-menu";
import { Button } from "@/ds/shadcn/components/ui/button";

export interface ListItemProps extends PropsWithChildren, DataViewItemBaseProps {
	className?: string;
	onClick?: () => void;
}

export const ListItem = (props: ListItemProps) => {
	const {
		children,
		className,
		isLoading,
		error,
		onClick
	} = props;

	return (
		<>
			<TableRow className={cn("even:bg-muted/50 dark:even:bg-muted/10", className, isLoading && "pointer-events-none opacity-60", onClick && "cursor-pointer hover:bg-background-highlight dark:even:hover:bg-background-highlight transition-colors duration-150")} onClick={onClick}>
				{children}
			</TableRow>

			{
				error && (
					<TableRow>
						<TableCell colSpan={100} className="py-3 text-destructive">
							<div className="flex items-center gap-2 text-xs truncate">
								<AlertCircleIcon className="h-4 w-4 shrink-0" />
								{
									typeof error === "string"
										? error
										: error.problem.description
								}
							</div>
						</TableCell>
					</TableRow>
				)
			}
		</>
	);
};

export const ListItemMenu: FC<PropsWithChildren> = props => {
	const { children } = props;

	return (
		<DropdownMenu>
			<DropdownMenuTrigger asChild>
				<Button variant="ghost">
					<EllipsisVerticalIcon />
				</Button>
			</DropdownMenuTrigger>
			<DropdownMenuContent>
				{children}
			</DropdownMenuContent>
		</DropdownMenu>
	);
};
